import validate from "/usr/src/app/content/n3-redirections-legacy-13aa5902-bfc5-4b44-bdcf-bd87e873b45b/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-redirections-legacy-13aa5902-bfc5-4b44-bdcf-bd87e873b45b/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}